import { createLocalStorageStateHook } from 'use-local-storage-state';
export const useVitalSignsKey = createLocalStorageStateHook('vitalSignsKey', null);